// import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import {
//   SaveVideoCall,
//   DeleteVideoUrl,
// } from "../../Redux/actions/videoCallActions";
// import { useDispatch, useSelector } from "react-redux";
// import Sharemedicalrecords from "./Sharemedicalrecords";
// import { useNavigate } from "react-router-dom";
// import { APP_ROUTES } from "../../PageRouting/pageRoutes";
// import moment from "moment";
// import AppointmentService from "../../Services/AppointmentService";
// import { Flex, Spin } from "antd";
// import { collection, deleteDoc, doc, getDoc, getDocs, query, where } from "firebase/firestore";
// import { db } from "../../config/firebase";
// import { clearSelectedAppt, setSelectedAppt } from "../../Redux/actions/appointmentActions";

// const VideoCall = (props) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [url, setUrl] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const location = useLocation();
//   const { selectedAppt } = useSelector((state) => state.appt);
//   const { loggedUser } = useSelector((state) => state.auth);
//   const selectedPatient = location?.state?.selectedAppDetails;
//   const activePatient = JSON.parse(localStorage.getItem("patientData"));
//   const patientCode = activePatient?.patientId;
//   useEffect(() => {
//     getLink();
//   }, []);

//   useEffect(() => {
//     if (selectedAppt !== null) return;

//     // This selectedPatient is an appointment object coming through navigation state.
//     if (selectedPatient) {
//       dispatch(setSelectedAppt(selectedPatient));
//       return;
//     }

//     // Acts as a fallback. In any case appointmentDetails comes null!!
//     try {
//       const apptJson = localStorage.getItem("selectedAppt");
//       if (apptJson) {
//         const apptObj = JSON.parse(apptJson);
//         if (apptObj) {
//           dispatch(setSelectedAppt(apptObj));
//         }
//       }
//     } catch (error) {
//       console.error("Failed to parse selectedAppt from localStorage", error);
//     }
//   }, [selectedPatient, selectedAppt, dispatch]);

//   const convertUTCDate = (date, format) => {
//     if (!format) {
//       const d = new Date();
//       date = new Date(
//         moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
//         " " +
//         d.getHours() +
//         ":" +
//         d.getMinutes()
//       );
//     }
//     format = format || "MM/DD/YYYY";
//     return moment(new Date(date)).utc().format(format);
//   };
//   const closeVideo = () => {
//     setIsLoading(true);
//     // let payload = {
//     //   "appointmentId": selectedPatient.appointmentId,
//     //   "modifiedBy": patientCode,
//     //   "modifiedDate": convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
//     //   "patientId": patientCode,
//     //   "queueStatus": "N",
//     //   "userId": selectedPatient.userId,
//     //   "joiningDateTime": convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss")
//     // };
//     // AppointmentService.callQueueUpdate(payload).then((result) => {
//     //   dispatch(DeleteVideoUrl());
//     //   navigate(APP_ROUTES.DASHBOARD);
//     //  });

//     let payload = {
//       appointmentId: selectedPatient.appointmentId,
//       patientId: selectedPatient.patientId,
//       userId: selectedPatient.userId,
//       queueStatus: "N",
//     };
//     AppointmentService.updateQueueStatus(payload)
//       .then((result) => {
//         dispatch(DeleteVideoUrl());
//         deleteFirebaseCall(selectedAppt.appointmentId).then(() => {
//           setIsLoading(false);
//           localStorage.removeItem("callRoomId");
//           localStorage.removeItem("selectedAppt");
//           dispatch(clearSelectedAppt(null));
//           navigate(APP_ROUTES.LOGIN);
//         })
//       })
//       .catch((error) => {
//         setIsLoading(false);
//         console.error("Failed to update queue status:", error);
//       });
//   };

//   const deleteFirebaseCall = async (roomId) => {
//     try {
//       const callRef = doc(db, "calls", roomId);
//       const snap = await getDoc(callRef);

//       // Doc already gone → nothing to do
//       if (!snap.exists()) return;

//       const callData = snap.data();
//       const callerId = callData?.incomingCall?.callerId;

//       if (callerId !== selectedAppt?.patientId) {
//         console.warn("Non-caller attempted to delete call. Ignored.");
//         return;
//       }

//       await deleteDoc(callRef);

//     } catch (err) {
//       console.error("Error deleting Firebase call:", err);
//     }
//   };

//   const getLink = () => {
//     const header = {
//       "Content-Type": " application/json",
//       "x-secret":
//         "sEjtQtHalCl22p2CEIrKz6uIaR1KENqEyG4coWIoZEDrFpLgv8sqWDprEEv2rGrlZ6igUwYbHNDHFySF",
//     };

//     const data = {
//       license: "9ngZbjYYVrwxbubEnVdEmpePAyBTqlQkcDI1ICcV",
//       roomname: selectedPatient?.appointmentId,
//       name: selectedPatient?.patientName,
//       email: selectedPatient?.email ? selectedPatient?.email : "test@gmail.com",
//     };

//     // "https://cb.maggieplus.com/admin-api/client/meeting/authentication",
//     axios
//       .post("https://emeet.syncdigit.co.in:31010/token/issue", data, {
//         headers: header,
//       })
//       .then((result) => {
//         setUrl(result.data.url);
//       })
//       .catch((err) => {
//         console.error("Err", err);
//       });
//   };

//   useEffect(() => {
//     if (url) {
//       dispatch(
//         SaveVideoCall({
//           callurl: url,
//           callType: true,
//           apptDetails: selectedPatient,
//         })
//       );
//     }
//   }, [url]);

//   const handleShareClick = () => {
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };

//   return (
//     <div>
//       <div className="relative">
//         <div
//           id="videoload"
//           style={{
//             width: "100px",
//             height: "100vh",
//             margin: "auto",
//             textAlign: "center",
//             display: "none",
//           }}
//         >
//           Loading...
//         </div>
//         {url ? (
//           <div id="videoframe" className="h-screen">
//             <div
//               dangerouslySetInnerHTML={{
//                 __html: `<iframe id="ccc" src="${url}" allow="camera;microphone" style="width: 100%; height: 100vh; border: none;"></iframe>`,
//               }}
//             ></div>
//           </div>
//         ) : (
//           <div className="w-full h-screen flex items-center justify-center">
//             <Flex align="center" gap="middle">
//               <Spin size="large" tip="Loading" />
//             </Flex>
//           </div>
//         )}
//         <div className="flex items-center justify-between mx-2">
//           <button
//             onClick={handleShareClick}
//             className="border-primaryColor border bg-primaryColor rounded-md p-2 text-white flex items-center"
//           >
//             Share Medical Records
//           </button>
//           <button
//             onClick={() => closeVideo()}
//             disabled={isLoading}
//             className="border-red border bg-red-600 m-3 rounded-md p-2 text-white flex relative text-right items-center hover:bg-brand-hoverRed hover:border-brand-hoverRed disabled:opacity-50 disabled:cursor-not-allowed"
//           >
//             End Consultation
//           </button>
//         </div>
//         {showModal && (
//           <Sharemedicalrecords
//             userId={selectedPatient?.userId}
//             onClose={handleCloseModal}
//             selectedPatient={selectedPatient} // Passing this for handling family member records sharing
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default VideoCall;

// ─────────────────────────────────────────────────────────────────────────────
// PATIENT APP — VideoCall.js
// ─────────────────────────────────────────────────────────────────────────────

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { SaveVideoCall, DeleteVideoUrl } from "../../Redux/actions/videoCallActions";
import { useDispatch, useSelector } from "react-redux";
import Sharemedicalrecords from "./Sharemedicalrecords";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import moment from "moment";
import AppointmentService from "../../Services/AppointmentService";
import { Flex, Spin } from "antd";
import { deleteCallRecord } from "../../config/firebase";
import { clearSelectedAppt, setSelectedAppt } from "../../Redux/actions/appointmentActions";

const VideoCall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [url, setUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { selectedAppt } = useSelector((state) => state.appt);
  const { loggedUser } = useSelector((state) => state.auth);

  const selectedPatient = location?.state?.selectedAppDetails;
  const patientId = loggedUser?.patientId;

  // ─── Rehydrate selectedAppt if needed ─────────────────────────────────────
  useEffect(() => {
    if (selectedAppt !== null) return;
    if (selectedPatient) {
      dispatch(setSelectedAppt(selectedPatient));
      return;
    }
    try {
      const raw = localStorage.getItem("selectedAppt");
      if (raw) dispatch(setSelectedAppt(JSON.parse(raw)));
    } catch (e) {
      console.error("Failed to parse selectedAppt from localStorage", e);
    }
  }, [selectedPatient, selectedAppt, dispatch]);

  useEffect(() => {
    getLink();
  }, []);

  useEffect(() => {
    if (url) {
      dispatch(
        SaveVideoCall({
          callurl: url,
          callType: true,
          apptDetails: selectedPatient,
        })
      );
    }
  }, [url]);

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const getLink = () => {
    const data = {
      license: "9ngZbjYYVrwxbubEnVdEmpePAyBTqlQkcDI1ICcV",
      roomname: selectedPatient?.appointmentId,
      name: selectedPatient?.patientName,
      email: selectedPatient?.email || "test@gmail.com",
    };
    axios
      .post("https://emeet.syncdigit.co.in:31010/token/issue", data, {
        headers: {
          "Content-Type": "application/json",
          "x-secret":
            "sEjtQtHalCl22p2CEIrKz6uIaR1KENqEyG4coWIoZEDrFpLgv8sqWDprEEv2rGrlZ6igUwYbHNDHFySF",
        },
      })
      .then((r) => setUrl(r.data.url))
      .catch((err) => console.error("Video link error:", err));
  };

  /**
   * Patient clicked "End Consultation" (leave call).
   *
   * FIX: deleteCallRecord uses the patient's patientId as callerId.
   *   - If the patient was the caller (they initiated), the record is deleted
   *     → doctor's notification disappears.
   *   - If the doctor was the caller (patient was the receiver), ownership
   *     check inside deleteCallRecord prevents deletion — correct, because
   *     the doctor's side will clean up on their end.
   *
   * Previously this used `selectedAppt?.patientId` which could be null when
   * selectedAppt wasn't rehydrated yet, silently skipping the delete.
   * Now we use `loggedUser?.patientId` which is always available.
   */
  const closeVideo = async () => {
    setIsLoading(true);
    const appointmentId = selectedPatient?.appointmentId;

    try {
      await AppointmentService.updateQueueStatus({
        appointmentId,
        patientId: selectedPatient.patientId,
        userId: selectedPatient.userId,
        queueStatus: "N",
      });

      // Safe delete — only removes doc if patient was the original caller
      await deleteCallRecord(appointmentId, patientId);

      dispatch(DeleteVideoUrl());
      localStorage.removeItem("callRoomId");
      localStorage.removeItem("selectedAppt");
      dispatch(clearSelectedAppt(null));
      navigate(APP_ROUTES.LOGIN);
    } catch (error) {
      console.error("closeVideo error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="relative">
        <div
          id="videoload"
          style={{
            width: "100px",
            height: "100vh",
            margin: "auto",
            textAlign: "center",
            display: "none",
          }}
        >
          Loading...
        </div>
        {url ? (
          <div id="videoframe" className="h-screen">
            <div
              dangerouslySetInnerHTML={{
                __html: `<iframe id="ccc" src="${url}" allow="camera;microphone" style="width:100%;height:100vh;border:none;"></iframe>`,
              }}
            />
          </div>
        ) : (
          <div className="w-full h-screen flex items-center justify-center">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        )}
        <div className="flex items-center justify-between mx-2">
          <button
            onClick={() => setShowModal(true)}
            className="border-primaryColor border bg-primaryColor rounded-md p-2 text-white flex items-center"
          >
            Share Medical Records
          </button>
          <button
            onClick={closeVideo}
            disabled={isLoading}
            className="border-red border bg-red-600 m-3 rounded-md p-2 text-white flex relative text-right items-center hover:bg-brand-hoverRed hover:border-brand-hoverRed disabled:opacity-50 disabled:cursor-not-allowed"
          >
            End Consultation
          </button>
        </div>
        {showModal && (
          <Sharemedicalrecords
            userId={selectedPatient?.userId}
            onClose={() => setShowModal(false)}
            selectedPatient={selectedPatient}
          />
        )}
      </div>
    </div>
  );
};

export default VideoCall;
